module.exports = __webpack_public_path__ + "static/media/Crowding of teeth on one jaw 1.3e351bf6.png";